module.exports = __webpack_public_path__ + "img/ico-planner.c26a53fc.svg";